// extracted by mini-css-extract-plugin
export default {"root":"StatusPage-rebranding-module__root___1LzrO"};